import { Role } from "@app/constants";
import {
  CreateAccount,
  Account,
  UpdateAccount, 
} from "@app/types";
import HttpService from "@core/services/http/http.service";

class _AccountService {
  public getAccounts<T>(page: number, all?: string) {
    return HttpService.get<T>("/accounts", {
      queryParams: { page, all },
    });
  }

  public createAccount(body: CreateAccount) {
    return HttpService.post<Account>("/accounts", {
      body: {
        username: body.taiKhoan,
        password: body.matKhau,
        name: body.name,
        role: Role.COMPANY,
      },
    });
  }

  public deleteAccount(id: string) {
    return HttpService.delete(`/accounts/${id}`);
  }

  public updatedAccount(id: string, body: UpdateAccount) {
    const body1: any = { username: body.taiKhoan, name: body.name };

    if (body.matKhau) {
      body1.password = body.matKhau;
    }

    return HttpService.patch(`/accounts/${id}`, {
      body: {
        ...body1,
      },
    });
  }
}

const AccountService = new _AccountService();

export default AccountService;
